import type { FootmanLevelConfig } from "@/types/barracks.types"

// Pool of 20 medieval human fantasy first names for soldiers
export const SOLDIER_NAMES: string[] = [
  "Aldric",
  "Bran",
  "Cedric",
  "Duncan",
  "Edmund",
  "Gareth",
  "Harald",
  "Ivan",
  "Jareth",
  "Kael",
  "Leoric",
  "Magnus",
  "Osric",
  "Roderick",
  "Silas",
  "Theron",
  "Ulric",
  "Viktor",
  "Willem",
  "Yorick",
]

// Constants
export const RESPAWN_TIME_MS = 20000 // 20 seconds
export const RALLY_RADIUS = 120 // pixels - how far rally point can be set from barracks
export const ATTACK_RANGE = 30 // pixels - melee attack range
export const ATTACK_SPEED = 135 // frames between attacks (~2.25s at 60fps) - slow but powerful
export const DEFAULT_RALLY_OFFSET_Y = 20 // Default rally point 20px south of barracks

// Soldier stats per barracks level (moderate health with regen, slow but hard-hitting)
export const footmanLevelStats: FootmanLevelConfig[] = [
  { name: "Footman", health: 360, damage: { min: 24, max: 36 }, armor: 1, speed: 2.5, healthRegen: 5 },
  { name: "Militia", health: 480, damage: { min: 30, max: 48 }, armor: 2, speed: 2.5, healthRegen: 8 },
  { name: "Swordsman", health: 630, damage: { min: 40, max: 60 }, armor: 3, speed: 2.8, healthRegen: 12 },
  { name: "Man-at-Arms", health: 780, damage: { min: 48, max: 72 }, armor: 4, speed: 2.8, healthRegen: 16 },
  { name: "Knight", health: 960, damage: { min: 60, max: 90 }, armor: 5, speed: 3.0, healthRegen: 22 },
  { name: "Champion", health: 1200, damage: { min: 76, max: 114 }, armor: 6, speed: 3.0, healthRegen: 30 },
  { name: "Royal Guard", health: 1500, damage: { min: 96, max: 144 }, armor: 8, speed: 3.2, healthRegen: 40 },
]

// Get config for a given barracks level (1-7)
export const getFootmanConfig = (level: number): FootmanLevelConfig => {
  const index = Math.max(0, Math.min(level - 1, footmanLevelStats.length - 1))
  return footmanLevelStats[index]
}
